import React, { useState } from 'react'
import { Row, Col, Card, Tooltip } from 'antd'

import './CodStats.css'

const COD_PROBLEMATIC_STATUS = "Lost"

const mapCodOrderToFilters = {
  'all':  { isRemittance: null, completeDelivered: null, isCodRefunded: null, internalStatus: null, notInternalStatus: null },
  'pending' : { isRemittance: false, completeDelivered: false, isCodRefunded: false, internalStatus: null, notInternalStatus: COD_PROBLEMATIC_STATUS },
  'pendingRemittance': { isRemittance: false, completeDelivered: true, isCodRefunded: false, internalStatus: null, notInternalStatus: null },
  'returned': { isRemittance: false, completeDelivered: false, isCodRefunded: true, internalStatus: null, notInternalStatus: null },
  'remitted': { completeDelivered: null, isRemittance: true, isCodRefunded: false, internalStatus: null, notInternalStatus: null },
  'problematic': { completeDelivered: null, isRemittance: false, isCodRefunded: false, internalStatus: COD_PROBLEMATIC_STATUS, notInternalStatus: null },
}

const CodStats = ({ stats, onSelect, currencyCode }) => {
  const [selected, setSelected] = useState()

  const handleSelect = selected => {
    setSelected(selected)

    onSelect(mapCodOrderToFilters[selected])
  }

  return (
    <Row className="mb-2 cod-stats" gutter={16}>
      <Col flex={1}>
        <Card hoverable={true} onClick={() => handleSelect('pending')} className={`${selected === 'pending' ? "selected" : ""}`}>
            <div style={{ textAlign: "center", color: "#575757" }}>
            <p style={{ fontSize: 30 }}>IN DELIVERY</p>
            { stats.pendingCod && 
              <p className="user-info">
                  Count: <strong>{stats.pendingCod?.count}</strong>
                  <br />
                  Amount: <strong>{currencyCode} {stats.pendingCod?.amount}</strong>
              </p>
            }
            </div>
        </Card>
      </Col>

      <Col flex={1}>
        <Card hoverable={true} onClick={() => handleSelect('pendingRemittance')} className={`${selected === 'pendingRemittance' ? "selected" : ""}`}>
            <div style={{ textAlign: "center", color: "#575757" }}>
            <Tooltip title="PENDING REMITTANCE">
              <p style={{ fontSize: 30 }}>PENDING REMITTANCE</p>
            </Tooltip>
            { stats.pendingRemittanceCod && 
              <p className="user-info">
                  Count: <strong>{stats.pendingRemittanceCod?.count}</strong>
                  <br />
                  Amount: <strong>{currencyCode} {stats.pendingRemittanceCod?.amount}</strong>
              </p>
            }
            </div>
        </Card>
      </Col>

      <Col flex={1}>
        <Card hoverable={true} onClick={() => handleSelect('returned')} className={`${selected === 'returned' ? "selected" : ""}`}>
            <div style={{ textAlign: "center", color: "#575757" }}>
            <p style={{ fontSize: 30 }}>RETURNED</p>
            { stats.refundedCod && 
              <p className="user-info">
                  Count: <strong>{stats.refundedCod?.count}</strong>
                  <br />
                  Amount: <strong>{currencyCode} {stats.refundedCod?.amount}</strong>
              </p>
            }
            </div>
        </Card>
      </Col>

      <Col flex={1}>
        <Card hoverable={true} onClick={() => handleSelect('remitted')} className={`${selected === 'remitted' ? "selected" : ""}`}>
            <div style={{ textAlign: "center", color: "#575757" }}>
            <p style={{ fontSize: 30 }}>REMITTED</p>
            { stats.remittedCod && 
              <p className="user-info">
                  Count: <strong>{stats.remittedCod?.count}</strong>
                  <br />
                  Amount: <strong>{currencyCode} {stats.remittedCod?.amount}</strong>
              </p>
            }
            </div>
        </Card>
      </Col>

      <Col flex={1}>
        <Card hoverable={true} onClick={() => handleSelect('problematic')} className={`${selected === 'problematic' ? "selected" : ""}`}>
            <div style={{ textAlign: "center", color: "#575757" }}>
            <p style={{ fontSize: 30 }}>PROBLEMATIC</p>
            { stats.problematicCod && 
              <p className="user-info">
                  Count: <strong>{stats.problematicCod?.count}</strong>
                  <br />
                  Amount: <strong>{currencyCode} {stats.problematicCod?.amount}</strong>
              </p>
            }
            </div>
        </Card>
      </Col>
    </Row>
  )
}

export default CodStats